<template>
    <div class="main-body">
        <h2>{{ $strings('cpsite/tpl/title') }}</h2>
        <div class="action-bar">
            <div class="add-wrapper">
                <el-button size="small" type="primary" @click="onCreate">{{ $strings('word/create') }}</el-button>
            </div>
            <div class="filter-wrapper">
                <el-form :inline="true" :model="formFilter" class="demo-form-inline" ref="filter">
                    <el-form-item label="">
                        <el-input v-model="formFilter.tpl_name" :placeholder="$strings('word/name')" size="small"
                                  class="max-width-120" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <FilterSize class="max-width-120" v-model="pagination.size"/>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="onFilter" size="small">{{ $strings('word/query') }}</el-button>
                        <el-button @click="onReset" size="small">{{ $strings('word/reset') }}</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="data-area">
            <el-table
                v-loading="loading"
                border
                :data="tableData"
                style="width: 100%">
                <el-table-column prop="tpl_id" :label="$strings('word/id')" width="100">
                    <template slot-scope="scope"><span class="code-text">{{ scope.row.tpl_id }}</span></template>
                </el-table-column>
                <el-table-column prop="tpl_name" :label="$strings('word/name')" width="180"></el-table-column>
                <el-table-column prop="tpl_status" :label="$strings('word/status')" width="100" sortable>
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.remark" placement="top-start"
                                    v-if="scope.row.tpl_status === statusRejected">
                            <el-link type="danger">
                                {{ $strings('cpsite/tpl/tpl_status_str/' + scope.row.tpl_status) }}
                                <i class="el-icon-question"></i>
                            </el-link>
                        </el-tooltip>
                        <el-link v-else>{{ $strings('cpsite/tpl/tpl_status_str/' + scope.row.tpl_status) }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="tpl_content" :label="$strings('word/content')">
                </el-table-column>
                <el-table-column prop="ct_time" label="CreateTime" width="160">
                    <template slot-scope="scope">
                        {{ convertUnixToDate(scope.row.ct_time) }}
                    </template>
                </el-table-column>
                <el-table-column label="Edit" width="160">
                    <template slot-scope="scope">
                        <el-button size="small" @click="onEdit(scope.row)" class="margin-right-10">Edit</el-button>
                        <el-popconfirm @confirm="onDrop(scope.row)" :title="$strings('word/drop_this_item')">
                            <el-button slot="reference" size="small" type="danger">{{ $strings('word/delete') }}
                            </el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination margin-top-1" v-if="pagination.total > pagination.size" style="text-align: right">
                <el-pagination background layout="prev, pager, next" :total="pagination.total"
                               :page-size.sync="pagination.size"
                               :current-page.sync="pagination.page" @current-change="refreshData"></el-pagination>
            </div>
        </div>
        <el-dialog
            :title="isEdit ? $strings('word/edit') : $strings('word/create')"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            @closed="onClose"
            width="30%">
            <div>
                <el-form ref="form" :model="editForm" label-width="80px" :rules="rules">
                    <el-form-item :label="$strings('cpsite/tpl/prop_tpl_name')" prop="tpl_name">
                        <el-input v-model="editForm.tpl_name" clearable maxlength="24" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item :label="$strings('cpsite/tpl/prop_tpl_content')" prop="tpl_content"
                                  style="margin-bottom: 0;">
                        <el-input type="textarea" rows="4" v-model="editForm.tpl_content" clearable maxlength="128"
                                  show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="" prop="remark">
                        <Hint
                            :message="`You can insert variable holder like: {{name}}, templates with variable can only use through API`"
                            hname="hint-style"/>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{ $strings('word/cancel') }}</el-button>
                <el-button type="primary" @click="onSaveEdit()" :loading="saving">{{ $strings('word/save') }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {API_STATUS_CODE, STORAGE_KEY_LOGIN_TZ, TPL_STATUS} from "@/config/config";
import {GetItem} from "@/utils/storage";
import {CpSiteTplCreate, CpSiteTplRead, CpSiteTplUpdate} from "@/api/cpsite/api";
import Hint from '@/components/hint';
import {UnixToDateFull} from "../../../utils/time";
import {CpSiteTplDrop} from "../../../api/cpsite/api";
import FilterSize from '@/components/filter/size';

export default {
    name: "cpsite-tpl",
    components: {Hint, FilterSize},
    data() {
        return {
            loading: true,
            isEdit: false,
            saving: false,
            editForm: {},
            formFilter: {size: 0, page: 0},
            pagination: {total: 0, size: 8, page: 1},
            tableData: [],
            dialogVisible: false,
            statusRejected: TPL_STATUS.REJECTED,
            rules: {
                tpl_name: [
                    {required: true, message: this.$strings('word/field_empty'), trigger: 'blur'}
                ],
                tpl_content: [
                    {required: true, message: this.$strings('word/field_empty'), trigger: 'blur'}
                ]
            },

        }
    },
    mounted() {
        this.refreshData();
    },
    computed: {},
    methods: {
        convertUnixToDate(ts) {
            let tz = parseInt(GetItem(STORAGE_KEY_LOGIN_TZ))
            return UnixToDateFull(ts, tz);
        },
        onFilter() {
            this.refreshData();
        },
        onReset() {
            this.formFilter = {};
            this.refreshData();
        },
        onClose() {
            this.saving = false
            this.$refs["form"].clearValidate();
        },
        onEdit(row) {
            this.isEdit = true;
            this.editForm = JSON.parse(JSON.stringify(row));
            this.dialogVisible = true;
        },
        onDrop({tpl_id}) {
            this.loading = true;
            CpSiteTplDrop({tpl_id: tpl_id}).then(() => {
                this.refreshData();
            });
        },
        onCreate() {
            this.isEdit = false;
            this.editForm = {};
            this.dialogVisible = true;
        },
        onSaveEdit() {
            this.saving = true;
            let action = this.isEdit ? CpSiteTplUpdate : CpSiteTplCreate;
            action(this.editForm).then((resp) => {
                if (resp.data.code === API_STATUS_CODE.SUCCESS) {
                    this.dialogVisible = false;
                    this.isEdit = false;
                    this.refreshData();
                }
            }).finally(() => {
                this.loading = false;
            })
        },
        refreshData() {
            this.loading = true;
            this.formFilter.size = this.pagination.size;
            this.formFilter.page = this.pagination.page;
            CpSiteTplRead(this.formFilter).then((resp) => {
                this.tableData = resp.data.data.total > 0 ? resp.data.data.rows : [];
                this.pagination.total = resp.data.data.total;
            }).finally(() => {
                this.loading = false;
            })
        },
    }
}
</script>

<style scoped lang="scss">
.action-bar {
    display: flex;
    flex-direction: row;

    .filter-wrapper {
        display: flex;
        justify-content: flex-end;
        flex-grow: 1;
    }

    .add-wrapper {
        padding-top: 4px;
    }
}

.table-pagination {
    margin-top: 1em;
    display: flex;
    justify-content: flex-end;
}

.hint-style {
    margin-top: 1em;
}
</style>